/**
 * Copper Grove Creations — Product Personalizer
 *
 * HOW TO ADD / EDIT PRODUCTS:
 * Edit the PRODUCTS array below. For each product you need:
 *   - variantId: find this in Shopify Admin > Products > click product > click variant > check URL for the ID
 *   - blankImage: the URL of your product blank (upload to Shopify Files, then copy URL)
 *   - placement: where on the blank image (in pixels at 600x600) the design should sit
 *     { x, y, width, height } — top-left corner + dimensions of the print zone
 *   - fullWrapPlacement: placement when "Full Wrap" is selected (usually covers the whole product face)
 *
 * To find placement coordinates: open your blank image in any image editor,
 * note the pixel coordinates of where the print area starts and its size.
 * Then scale those to a 600x600 grid (multiply by 600 / yourImageWidth).
 */

// ─── PRODUCT CONFIGURATION ────────────────────────────────────────────────────
const PRODUCTS = [
  {
    id: 'tumbler-40oz',
    name: '40oz Skinny Tumbler',
    variantId: 0, // ← Replace with your Shopify variant ID
    price: 3500,  // price in cents ($35.00)
    blankImage: 'https://cdn.shopify.com/s/files/1/0700/3370/3080/files/black-40oz-handled-tumbler-blank-copper-grove-creations.png?v=1782315089', // ← your blank URL
    placement: { x: 170, y: 160, width: 260, height: 280 },
    fullWrapPlacement: { x: 60, y: 80, width: 480, height: 440 },
    category: 'Drinkware',
  },
  
 {
  id: 'coaster',
  name: 'Sandstone Coaster',
  variantId: 0,
  price: 1800,
  blankImage: 'https://cdn.shopify.com/s/files/1/0700/3370/3080/files/master-slate-coaster-blank-4x4.png?v=1782318193',

  placement: {
    x: 70,
    y: 70,
    width: 460,
    height: 460
  },

  fullWrapPlacement: {
    x: 40,
    y: 40,
    width: 520,
    height: 520
  },

  category: 'Kitchen'
},
  
];
// ─── END PRODUCT CONFIGURATION ────────────────────────────────────────────────


// ─── APP STATE ────────────────────────────────────────────────────────────────
const state = {
  originalFile: null,
  originalImage: null,
  processedImage: null,
  bgRemoved: false,
  bgRemoving: false,
  printType: 'laser',
  wrapStyle: 'centered',
  selectedProduct: null,
  quantity: 1,

scale: 1,
offsetX: 0,
offsetY: 0,

dragging: false,
dragStartX: 0,
dragStartY: 0,

engraveStrength: 60,
};

// ─── DOM REFS ─────────────────────────────────────────────────────────────────
const $ = id => document.getElementById(id);

// ─── INIT ─────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  setupUpload();
  setupOptions();
  setupModal();
});

// ─── UPLOAD ───────────────────────────────────────────────────────────────────
function setupUpload() {
  const zone = $('upload-zone');
  const trigger = $('upload-trigger');
  const input = $('photo-upload');
  const removeBtn = $('remove-upload');

  trigger.addEventListener('click', () => input.click());

  input.addEventListener('change', e => {
    if (e.target.files[0]) handleFile(e.target.files[0]);
  });

  zone.addEventListener('dragover', e => { e.preventDefault(); zone.classList.add('drag-over'); });
  zone.addEventListener('dragleave', () => zone.classList.remove('drag-over'));
  zone.addEventListener('drop', e => {
    e.preventDefault();
    zone.classList.remove('drag-over');
    if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  });

  removeBtn.addEventListener('click', resetUpload);
}

async function handleFile(file) {
  const extension = file.name.split('.').pop().toLowerCase();

if (
  !file.type.startsWith('image/') &&
  extension !== 'heic' &&
  extension !== 'heif'
) {
  showToast('Please upload JPG, PNG, WEBP, or HEIC image.', 'error');
  return;
}
  if (file.size > 20 * 1024 * 1024) { showToast('Image must be under 20MB.', 'error'); return; }

if (extension === 'heic' || extension === 'heif') {
  try {
    const convertedBlob = await heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.9
    });

    file = new File(
      [convertedBlob],
      file.name.replace(/\.(heic|heif)$/i, '.jpg'),
      { type: 'image/jpeg' }
    );

    console.log('HEIC converted successfully');
  } catch (err) {
    console.error('HEIC conversion failed', err);
    showToast('Could not process HEIC image.', 'error');
    return;
  }
}

  state.originalFile = file;
  state.bgRemoved = false;
  $('bg-remove-toggle').checked = false;

  const url = URL.createObjectURL(file);
  $('preview-img').src = url;
  $('upload-trigger').classList.add('hidden');
  $('upload-preview').classList.remove('hidden');

  console.log('Uploading:', file.name);

const img = new Image();

await new Promise((resolve, reject) => {
  img.onload = resolve;
  img.onerror = reject;
  img.src = URL.createObjectURL(file);
});

state.originalImage = img;
state.processedImage = img;

  show('step-options');
  show('step-products');
  renderProductGrid();
}

function resetUpload() {
  state.originalFile = null;
  state.originalImage = null;
  state.processedImage = null;
  state.bgRemoved = false;

  $('photo-upload').value = '';
  $('preview-img').src = '';
  $('upload-trigger').classList.remove('hidden');
  $('upload-preview').classList.add('hidden');

  hide('step-options');
  hide('step-products');
  $('product-grid').innerHTML = '';
}

// ─── OPTIONS ──────────────────────────────────────────────────────────────────
function setupOptions() {
  // Print type
  document.querySelectorAll('#print-type-group .toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('#print-type-group .toggle-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state.printType = btn.dataset.value;
      updatePrintHint();
      redrawAllCards();
    });

  });

  // Wrap style
  document.querySelectorAll('#wrap-style-group .toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('#wrap-style-group .toggle-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state.wrapStyle = btn.dataset.value;
      updateWrapHint();
      redrawAllCards();
    });
  });

  // Background removal
  $('bg-remove-toggle').addEventListener('change', async e => {
    if (!state.originalImage) return;
    if (e.target.checked) {
      await removeBackground();
    } else {
      state.processedImage = state.originalImage;
      state.bgRemoved = false;
      redrawAllCards();
    }
  });
  // Zoom controls
if ($('zoom-in')) {
  $('zoom-in').addEventListener('click', () => {
    state.scale = Math.min(state.scale * 1.1, 5);
    redrawAllCards();
  });
}

if ($('zoom-out')) {
  $('zoom-out').addEventListener('click', () => {
    state.scale = Math.max(state.scale * 0.9, 0.2);
    redrawAllCards();
  });
}
if ($('engrave-strength')) {
  $('engrave-strength').addEventListener('input', e => {
    state.engraveStrength = Number(e.target.value);
    redrawAllCards();
  });
}

}

function updatePrintHint() {
  const hints = {
    laser: 'Laser engraving burns your design into the surface for a permanent, elegant look.',
    uv: 'UV printing delivers full-color, photorealistic results directly onto the product.',
  };
  $('print-type-hint').textContent = hints[state.printType];
  if (state.printType === 'laser') {
    $('laser-warning').classList.remove('hidden');
  } else {
    $('laser-warning').classList.add('hidden');
  }
}

function updateWrapHint() {
  const hints = {
    centered: 'Your design is placed in the center of the product.',
    fullwrap: 'Your design stretches across the full printable area of the product.',
  };
  $('wrap-style-hint').textContent = hints[state.wrapStyle];
}

// ─── BACKGROUND REMOVAL ───────────────────────────────────────────────────────
async function removeBackground() {
  showToast('Background removal coming next. Feature temporarily disabled.', 'success');
}


// ─── PRODUCT GRID ─────────────────────────────────────────────────────────────
function renderProductGrid() {
  const grid = $('product-grid');
  grid.innerHTML = '';

  PRODUCTS.forEach(product => {
    const card = document.createElement('div');
    card.className = 'product-card';
    card.dataset.productId = product.id;

    const canvas = document.createElement('canvas');
    canvas.width = 300;
    canvas.height = 300;
    canvas.className = 'product-card-canvas';

    const info = document.createElement('div');
    info.className = 'product-card-info';
    info.innerHTML = `
      <span class="product-card-name">${product.name}</span>
      <span class="product-card-price">${formatPrice(product.price)}</span>
    `;

    card.appendChild(canvas);
    card.appendChild(info);
    grid.appendChild(card);

    drawProductCanvas(canvas, product, 300);

    card.addEventListener('click', () => openModal(product));
  });
}

function redrawAllCards() {
  document.querySelectorAll('.product-card').forEach(card => {
    const product = PRODUCTS.find(p => p.id === card.dataset.productId);
    const canvas = card.querySelector('canvas');
    if (product && canvas) drawProductCanvas(canvas, product, 300);
  });

  // Also redraw modal if open
  if (state.selectedProduct) {
    drawProductCanvas($('modal-canvas'), state.selectedProduct, 600);
  }
}

// ─── CANVAS DRAWING ───────────────────────────────────────────────────────────
function drawProductCanvas(canvas, product, size) {
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, size, size);

  const scale = size / 600;

  // Draw blank product image
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => {
    ctx.drawImage(img, 0, 0, size, size);

    // Overlay the customer image
    if (state.processedImage) {
      const placement = state.wrapStyle === 'fullwrap'
        ? product.fullWrapPlacement
        : product.placement;

      const px = placement.x * scale;
      const py = placement.y * scale;
      const pw = placement.width * scale;
      const ph = placement.height * scale;

      ctx.save();

      // Clip to placement area
      ctx.beginPath();
      ctx.rect(px, py, pw, ph);
      ctx.clip();

      // For laser: apply grayscale + multiply blend
     if (state.printType === 'laser') {

  // Create engraved metal effect
 const strength = state.engraveStrength || 60;

ctx.filter = 'grayscale(100%) contrast(220%) brightness(115%)';

ctx.globalCompositeOperation = 'overlay';
ctx.globalAlpha = 0.35;
} else {

  ctx.filter = 'none';
  ctx.globalCompositeOperation = 'source-over';
  ctx.globalAlpha = 0.95;

}

      // Fit image into placement area maintaining aspect ratio
      const iw = state.processedImage.width;
      const ih = state.processedImage.height;
     const fit = fitContain(
  iw,
  ih,
  px,
  py,
  pw,
  ph
);

const dw = fit.dw * state.scale;
const dh = fit.dh * state.scale;

const dx =
  fit.dx -
  ((dw - fit.dw) / 2) +
  state.offsetX;

const dy =
  fit.dy -
  ((dh - fit.dh) / 2) +
  state.offsetY;

const centerX = dx + (fit.dw / 2);
const centerY = dy + (fit.dh / 2);

ctx.drawImage(
  state.processedImage,
  centerX - dw / 2,
  centerY - dh / 2,
  dw,
  dh
);
      ctx.restore();
    }
  };
  img.src = product.blankImage;
}

/** Fit source dimensions into target rect while maintaining aspect ratio (contain) */
function fitContain(iw, ih, tx, ty, tw, th) {
  const scaleW = tw / iw;
  const scaleH = th / ih;
  const s = Math.min(scaleW, scaleH);
  const dw = iw * s;
  const dh = ih * s;
  const dx = tx + (tw - dw) / 2;
  const dy = ty + (th - dh) / 2;
  return { dx, dy, dw, dh };
}

// ─── MODAL ────────────────────────────────────────────────────────────────────
function setupModal() {

  if ($('modal-backdrop')) {
    $('modal-backdrop').addEventListener('click', closeModal);
  }

  if ($('modal-close')) {
    $('modal-close').addEventListener('click', closeModal);
  }

  if ($('qty-down')) {
    $('qty-down').addEventListener('click', () => {
      if (state.quantity > 1) {
        state.quantity--;
        $('qty-input').value = state.quantity;
      }
    });
  }

  if ($('qty-up')) {
    $('qty-up').addEventListener('click', () => {
      if (state.quantity < 99) {
        state.quantity++;
        $('qty-input').value = state.quantity;
      }
    });
  }

  if ($('qty-input')) {
    $('qty-input').addEventListener('change', e => {
      state.quantity = Math.max(
        1,
        Math.min(99, parseInt(e.target.value) || 1)
      );
      e.target.value = state.quantity;
    });
  }

  if ($('btn-add-cart')) {
    $('btn-add-cart').addEventListener('click', handleAddToCart);
  }
}

function openModal(product) {
  state.selectedProduct = product;

  const modal = $('product-modal');
  if (modal) {
    modal.classList.remove('hidden');
  }

  drawProductCanvas($('modal-canvas'), product, 600);
}

function closeModal() {
  const modal = $('product-modal');

  if (modal) {
    modal.classList.add('hidden');
  }

  document.body.style.overflow = '';
  state.selectedProduct = null;
}

// ─── ADD TO CART ──────────────────────────────────────────────────────────────
async function handleAddToCart() {
  const product = state.selectedProduct;
  if (!product || product.variantId === 0) {
    showToast('This product is not yet configured. Check back soon!', 'error');
    return;
  }

  const btn = $('btn-add-cart');
  const spinner = $('cart-spinner');
  const btnText = $('cart-btn-text');

  btn.disabled = true;
  btnText.textContent = 'Uploading…';
  spinner.classList.remove('hidden');

  try {
    // 1. Upload original image
    const originalUrl = await uploadToImgBB(state.originalFile, `original-${Date.now()}`);

    // 2. Render mockup canvas to blob and upload
    const mockupBlob = await canvasToBlob($('modal-canvas'));
    const mockupFile = new File([mockupBlob], `mockup-${Date.now()}.png`, { type: 'image/png' });
    const mockupUrl = await uploadToImgBB(mockupFile, `mockup-${Date.now()}`);

    btnText.textContent = 'Adding to Cart…';

    // 3. Add to Shopify cart with line item properties
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: product.variantId,
          quantity: state.quantity,
          properties: {
            'Print Type': state.printType === 'laser' ? 'Laser Engrave' : 'UV Print',
            'Wrap Style': state.wrapStyle === 'fullwrap' ? 'Full Wrap' : 'Centered',
            'Background Removed': state.bgRemoved ? 'Yes' : 'No',
            '_Original Image': originalUrl,
            '_Mockup Preview': mockupUrl,
          },
        }],
      }),
    });

    if (!response.ok) throw new Error('Cart add failed');

    showToast(`${product.name} added to cart!`, 'success');
    closeModal();

    // Refresh cart drawer / bubble if theme supports it
    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (err) {
    console.error('Add to cart error:', err);
    showToast('Something went wrong. Please try again.', 'error');
  } finally {
    btn.disabled = false;
    btnText.textContent = 'Add to Cart';
    spinner.classList.add('hidden');
  }
}

// ─── IMAGE UPLOAD (ImgBB) ─────────────────────────────────────────────────────
async function uploadToImgBB(file, name) {
  const apiKey = window.__imgbbKey;
  if (!apiKey || apiKey === 'YOUR_IMGBB_API_KEY_HERE') {
    console.warn('ImgBB API key not set — using placeholder URL');
    return 'https://placeholder.com/image-not-uploaded';
  }

  const formData = new FormData();
  formData.append('key', apiKey);
  formData.append('image', file);
  formData.append('name', name);

  const res = await fetch('https://api.imgbb.com/1/upload', {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) throw new Error('ImgBB upload failed');
  const data = await res.json();
  return data.data.url;
}

// ─── HELPERS ──────────────────────────────────────────────────────────────────
function canvasToBlob(canvas) {
  return new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
}

function formatPrice(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function show(id) { $(id).classList.remove('hidden'); }
function hide(id) { $(id).classList.add('hidden'); }

function showToast(message, type = 'info') {
  const toast = $('toast');
  toast.textContent = message;
  toast.className = `toast toast--${type}`;
  toast.classList.remove('hidden');
  setTimeout(() => toast.classList.add('hidden'), 3500);
}

/* ==========================
   DRAG TO MOVE DESIGN
========================== */

document.addEventListener('mousedown', e => {
  if (!e.target.closest('canvas')) return;

  state.dragging = true;
  state.dragStartX = e.clientX;
  state.dragStartY = e.clientY;
});

document.addEventListener('mousemove', e => {
  if (!state.dragging) return;

  state.offsetX += e.clientX - state.dragStartX;
  state.offsetY += e.clientY - state.dragStartY;

  state.dragStartX = e.clientX;
  state.dragStartY = e.clientY;

  redrawAllCards();
});

document.addEventListener('mouseup', () => {
  state.dragging = false;
});

/* Mobile Touch Support */

document.addEventListener('touchstart', e => {
  if (!e.target.closest('canvas')) return;

  state.dragging = true;
  state.dragStartX = e.touches[0].clientX;
  state.dragStartY = e.touches[0].clientY;
});

document.addEventListener('touchmove', e => {
  if (!state.dragging) return;

  state.offsetX += e.touches[0].clientX - state.dragStartX;
  state.offsetY += e.touches[0].clientY - state.dragStartY;

  state.dragStartX = e.touches[0].clientX;
  state.dragStartY = e.touches[0].clientY;

  redrawAllCards();
});

document.addEventListener('touchend', () => {
  state.dragging = false;
});